export default "__VITE_ASSET__DSmmMLlU__"